module.exports = __webpack_public_path__ + "static/media/4.4d9b8023.jpg";